import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareH = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler8') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler8', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Superior drop!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Superior drop!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareH}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareH
  
